import { render, staticRenderFns } from "./AdminFinanceMenu.vue?vue&type=template&id=efac848e"
import script from "./AdminFinanceMenu.vue?vue&type=script&lang=js"
export * from "./AdminFinanceMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports